// QueryProvider: React Query를 통해 서버 데이터 요청, 캐싱, 상태 관리 기능을 앱 전체에 공급하는 Provider
// - QueryClient: React Query의 핵심 객체로, 쿼리 캐싱/옵션/상태를 관리함
// - QueryClientProvider: 하위 컴포넌트에서 React Query 기능을 사용할 수 있도록 context를 제공
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

// queryClient: 쿼리 동작 기본 옵션 설정
// - refetchOnWindowFocus: 창 포커스 시 자동 재요청 여부(false면 자동 재요청 안함)
// - retry: 실패 시 재시도 횟수(1회)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// QueryProviderProps: 하위 컴포넌트(children)를 감싸서 React Query context를 공급
interface QueryProviderProps {
  children: ReactNode;
}

// QueryProvider 컴포넌트
// - queryClient를 context로 공급하여 하위에서 useQuery, useMutation 등 React Query API 사용 가능
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
